import I18n from 'i18n-js';
import React, { Component } from 'react';
import { bool, func, shape, string } from 'prop-types';
import { connect } from 'react-redux';
import { login } from '../actions/auth';
import Input from '../../common/components/Input';
import { get } from '../../../container';

class Signin extends Component {
  static propTypes = {
    login: func.isRequired,
    errorLogin: string,
    unauthorized: bool.isRequired,
    location: shape().isRequired,
  };

  static defaultProps = {
    errorLogin: null,
  };

  constructor() {
    super();

    this.onValidate = this.onValidate.bind(this);
    this.setUsername = this.setUsername.bind(this);
    this.setPassword = this.setPassword.bind(this);
  }

  /**
   * @param {Object?} event
   */
  onValidate(event) {
    if (event) {
      event.preventDefault();
    }

    const username = this.username.value;
    const password = this.password.value;

    if (!username || !password) {
      return;
    }

    this.props.login(username, password);
  }

  /**
   * @param {String} username
   */
  setUsername(username) {
    this.username = username;
  }

  /**
   * @param {String} username
   */
  setPassword(password) {
    this.password = password;
  }

  /**
   * {@inheritdoc}
   */
  render() {
    const { errorLogin, unauthorized } = this.props;

    return (
      <div className="login">
        <h1 className="login__title">
          {I18n.t('pages.signin.title')}
          <span>{I18n.t('pages.signin.subtitle')}</span>
        </h1>
        {unauthorized && (
          <p className="login__error">{I18n.t('pages.signin.unauthorized')}</p>
        )}
        <form onSubmit={this.onValidate}>
          <Input
            id="username"
            className="form-group__input--xl"
            label={I18n.t('pages.signin.username:label')}
            ref={this.setUsername}
          />
          <Input
            id="password"
            className="form-group__input--xl"
            label={I18n.t('pages.signin.password:label')}
            type="password"
            ref={this.setPassword}
          />
          {errorLogin && <p className="login__error">{I18n.t(`api.error.${errorLogin}`)}</p>}
          <button onClick={this.onValidate} className="button">
            {I18n.t('pages.signin.validation:button')}
          </button>
        </form>
        <p>
          {I18n.t('pages.signin.forgot_password')}
          <a href={`mailto:${get('utpa_email')}`} className="link">{I18n.t('pages.signin.forgot_password:email')}</a>
          {I18n.t('pages.signin.forgot_password:or')}
          <a href={`tel:${get('utpa_phone')}`} className="link">{I18n.t('pages.signin.forgot_password:phone')}</a>
        </p>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  unauthorized: state.auth.unauthorized,
  errorLogin: state.auth.error,
});

const mapDispatchToProps = dispatch => ({
  login: (username, password) => dispatch(login(username, password)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Signin);



// WEBPACK FOOTER //
// ./src/modules/auth/containers/Signin.js